var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.87 12.87"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.92,
  height: 17.42,
  x: 5.48,
  y: -2.27,
  rx: 0.96,
  ry: 0.96,
  transform: "rotate(-45 6.439 6.443)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.92,
  height: 17.42,
  x: 5.48,
  y: -2.27,
  rx: 0.96,
  ry: 0.96,
  transform: "rotate(45 6.443 6.439)"
})))));
export default SvgClose;